var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z3o0cwklwa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1255H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ylj2znp3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53 0c.209 0 .388.066.539.198.15.131.226.29.226.477v.56h1.983c.115 0 .21.033.286.1.075.068.113.15.113.246 0 .09-.04.17-.119.237a.418.418 0 0 1-.28.101h-.215v6.008a.612.612 0 0 1-.227.477.792.792 0 0 1-.539.198h-6.81a.792.792 0 0 1-.539-.198.612.612 0 0 1-.226-.477V1.919H.388a.397.397 0 0 1-.275-.101.313.313 0 0 1 0-.482.397.397 0 0 1 .275-.102H2.38V.675c0-.186.074-.346.221-.477A.786.786 0 0 1 3.147 0zm1.767 1.919h-6.81v6.008h6.81V1.919zM4.833 3.076c.104 0 .192.035.264.106a.299.299 0 0 1 .119.241v3.221a.318.318 0 0 1-.114.246.39.39 0 0 1-.269.101.39.39 0 0 1-.27-.101.318.318 0 0 1-.113-.246v-3.22c0-.097.038-.18.114-.247a.39.39 0 0 1 .269-.1zm-2.096 0c.108 0 .198.035.27.106a.299.299 0 0 1 .118.241v3.221a.318.318 0 0 1-.113.246.397.397 0 0 1-.275.101.397.397 0 0 1-.275-.101.318.318 0 0 1-.113-.246v-3.22c0-.097.038-.18.113-.247a.397.397 0 0 1 .275-.1zm4.17 0c.108 0 .198.035.27.106a.299.299 0 0 1 .118.241v3.221a.318.318 0 0 1-.113.246.397.397 0 0 1-.275.101.397.397 0 0 1-.274-.101.318.318 0 0 1-.114-.246v-3.22c0-.097.038-.18.114-.247a.397.397 0 0 1 .274-.1zM6.53.685H3.136v.55H6.53v-.55z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z3o0cwklwa)",
    transform: "translate(-801 -196)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ylj2znp3b)",
    transform: "translate(801 196.677)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5252",
    d: "M0 0h9.677v8.602H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/delete-btn.cfb9e11b621eba8517e652a3f58546f4.svg";
export { ForwardRef as ReactComponent };